import { Component } from '@angular/core';
import { Expert } from '../_types/expert';
import { Filter, FilterOperation } from 'src/app/core/jsonapi/filter';
import { ExpertsService } from '../_services/experts.service';
import { TopbarService } from 'src/app/core/topbar/topbar.service';
import { Router } from '@angular/router';
import { ConfirmationService, MessageService } from 'primeng/api';
import { IParamsCollection } from 'src/app/core/jsonapi/interfaces/params-collection';
import { FilterBuilder } from 'src/app/core/jsonapi/filters-builder';
import { firstValueFrom } from 'rxjs';
import { LoginService } from '../../login/login.service';
import { UsersService } from '../../users/_services/users.service';

@Component({
    selector: 'app-experts-list',
    templateUrl: './experts-list.component.html',
    styleUrls: ['./experts-list.component.scss'],
    host: { class: 'list-page' },
    standalone: false
})
export class ExpertsListComponent {
  public experts: Expert[] = [];
  public totalRecords: number = 0;
  public loading: boolean = false;
  private lastGridEvent: any;
  public filters: any = {
    name: new Filter(FilterOperation.contains, 'name'),
  };
  public allowDelete: boolean = false;

  constructor(
    private expertsService: ExpertsService,
    private topbarService: TopbarService,
    private router: Router,
    private confirmationService: ConfirmationService,
    private messageService: MessageService,
    private loginService: LoginService,
    private usersService: UsersService
  ) {
    
  }

  ngOnInit(): void {
    this.topbarService.setTitle("Peritos");
    this.topbarService.addAction("Nuevo", "pi pi-plus", false, () => {
      this.edit({} as Expert);
    });
    this.allowDelete = this.loginService.hasPermission("EXPERTS.DELETE");
  }

  public async loadData($event: any) {

    this.lastGridEvent = $event;

    let params: IParamsCollection = {
      sort: ['name'],
      page: { number: $event.first + 1, size: $event.rows }
    }

    if (typeof $event.sortField != "undefined") params.sort = [($event.sortOrder > 0 ? "-" : "") + $event.sortField];

    //creamos filtros
    params.filter = FilterBuilder.fromObject(this.filters).build();

    let response = await firstValueFrom(this.expertsService.all(params));
    this.experts = response.data;
    this.totalRecords = response.meta['total'];
    this.topbarService.setCount(this.totalRecords);
  }

  clearFilters() {
    this.filters = {};
    this.search();
  }

  search() {
    this.lastGridEvent.first = 0;
    this.loadData(this.lastGridEvent);
  }

  edit(expert: Expert) {
    this.router.navigate(['experts/' + (expert && Object.keys(expert).length > 0 ? expert.id : 0)]);
  }

  delete(client: any) {
    if (this.allowDelete) {
      this.confirmationService.confirm({
        message: "¿Está seguro que desea eliminar el perito?",
        header: "Eliminar perito",
        acceptLabel: "Aceptar",
        rejectLabel: "Cancelar",
        acceptButtonStyleClass: "p-button-danger",
        icon: 'pi pi-exclamation-triangle',
        accept: () => {
          this.expertsService.delete(client.id).subscribe({
            next: (data: any) => {
              

              if(client.userId){
                this.usersService.delete(client.userId).subscribe({
                  next: (data: any) => {      
                    this.messageService.add({ closable: true, severity: 'success', detail: "Perito eliminado correctamente" });
                    this.loadData(this.lastGridEvent);
                  },
                  error: (error: any) => {
                    this.messageService.add({ closable: true, severity: 'error', detail: error.error.title });
                  }
                });
                }else{
                  this.messageService.add({ closable: true, severity: 'success', detail: "Perito eliminado correctamente" });
                  this.loadData(this.lastGridEvent);
                }
            },
            error: (error: any) => {
              this.messageService.add({ closable: true, severity: 'error', detail: error.error.title });
            }
          });
        }
      });
    }
  }


}
